<template>
  <div class="search-area">
    <div class="wrapper">
      <div class="top">
        <div class="input-col-group">
          <div class="col">
            <PageSubTitle showText="SPOT运价"></PageSubTitle>起运港
          </div>
          <div class="col">目的港</div>
          <div class="col">船公司</div>
          <div class="col">箱型</div>
        </div>
        <div class="btn-col-group"></div>
      </div>
      <div class="bottom">
        <div class="col-wrapper">
          <div class="input-col-group">
            <div class="col col-1">
              <div class="port-icon-font">
                <letter-icon letter="A"></letter-icon>
              </div>
              <div class="col-input">
                <PortSearch
                  :isStart="true"
                  key="start"
                  :placeholder="'请选择起运港'"
                  :disabled="layout.showLoading"
                  v-model="form.portStartName"
                  @change="
                    () => {
                      form.portStartId = '';
                    }
                  "
                  @select="
                    (item) => {
                      form.portStartId = item.id;
                      form.portStartName = item.name;
                    }
                  "
                ></PortSearch>
                <div class="flag-col flag-col--start">
                  <PortIdentifying
                    :list="serviceModeList"
                    :disabled="layout.showLoading"
                    @change="flagStartChange"
                  ></PortIdentifying>
                </div>
              </div>
              <div class="col-split">
                <div class="arrow-circle">
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
            <div class="col col-2">
              <div class="port-icon-font">
                <letter-icon letter="B"></letter-icon>
              </div>
              <div class="col-input">
                <PortSearch
                  key="end"
                  :placeholder="'请选择目的港'"
                  :disabled="layout.showLoading"
                  v-model="form.portEndName"
                  @change="
                    () => {
                      form.portEndId = '';
                    }
                  "
                  @select="
                    (item) => {
                      form.portEndId = item.id;
                      form.portEndName = item.name;
                    }
                  "
                ></PortSearch>
                <div class="flag-col flag-col--end">
                  <PortIdentifying
                    :list="serviceModeList"
                    :disabled="layout.showLoading"
                    @change="flagStartChange"
                  ></PortIdentifying>
                </div>
              </div>
              <div class="col-split"></div>
            </div>
            <div class="col col-4">
              <div class="port-icon-font">
                <i class="iconfont icon-chuan"></i>
              </div>
              <div class="col-input">
                <el-select
                  v-input-focus
                  multiple
                  collapse-tags
                  :disabled="layout.showLoading"
                  class="multiple-select"
                  v-model="form.shippingList"
                  placeholder="请选择船公司"
                >
                  <el-option
                    v-for="item in shippingOptions"
                    :key="item.name"
                    :label="item.showName"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-split"></div>
            </div>
            <div class="col col-3">
              <div class="port-icon-font">
                <i class="iconfont icon-zhengxiang"></i>
              </div>
              <div class="col-input">
                <el-select
                  v-input-focus
                  v-model="form.containerType"
                  :disabled="layout.showLoading"
                  :placeholder="'请选择箱型'"
                >
                  <el-option
                    v-for="item in containerTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="btn-col-group">
            <div class="btn-wrapper">
              <el-button
                @click="searchClick"
                type="primary"
                class="button-col"
                icon="el-icon-search"
              >
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <login
      @close="showLogin = false"
      v-if="showLogin"
      @success="() => {}"
      @fail="() => {}"
    ></login>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import PortSearch from "../PortSearch.vue";
import PortIdentifying from "../PortIdentifying.vue";
import { Validator } from "@/utils/Validator";
import { getTargetInstance } from "@/utils/tool";
import { containerTypeOptions, shippingOptions } from "../../api/option";
export default {
  props: {
    layout: {
      type: Object,
      default: () => ({}),
    },
  },

  components: { PortSearch, PortIdentifying },
  data() {
    return {
      showLogin: false,
      form: {
        portStartId: "",
        portStartName: "",
        portEndId: "",
        portEndName: "",
        containerType: "",
        fromTransportType: "CY",
        toTransportType: "CY",
        shippingIds: "",
        shippingList: [],
      },
      // 箱型列表
      containerTypeOptions,
      shippingOptions,
      serviceModeList: [
        { id: 1, index: 0, name: "CY" },
        { id: 2, index: 1, name: "SD" },
      ],
      numData: 0, //查询次数
    };
  },
  computed: {
    //监听事件
    ...mapState("user", {
      userId: (state) => state.userId,
    }),
  },

  created() {},
  mounted() {},
  methods: {
    flagStartChange(item) {
      this.form.fromTransportType = item.name;
    },
    flagEndChange(item) {
      this.form.toTransportType = item.name;
    },
    // 运价校验
    check() {
      this.form.shippingIds = this.form.shippingList.join(",") || "";
      let va = new Validator();
      va.add(this.form.portStartId, [["isNotEmpty", "请选择起运港"]]);
      va.add(this.form.portEndId, [["isNotEmpty", "请选择目的港"]]);
      va.add(this.form.shippingIds, [["isNotEmpty", "请选择船公司"]]);
      va.add(this.form.containerType, [["isNotEmpty", "请选择箱型"]]);
      let { errorMsg } = va.start();
      return errorMsg;
    },
    // 运价传参
    getParams() {
      let form = { ...this.form };
      let list = [];
      this.form.shippingList.forEach(item => {
        let listItem = this.shippingOptions.find((item1) => {
          return item1.name == item;
        });
        list.push(listItem)
      });
      form.shippingOptions = list || [];
      let params = this.$omit(form,["shippingList"]);
      console.log("==========params", params);
      return params;
    },
    //运价查询
    searchClick() {
      if (this.layout.showLoading) {
        this.$message({
          message: "数据加载中",
          type: "warning",
        });
        return;
      }
      let checkRes = this.check();
      if (checkRes) {
        this.$message({
          message: checkRes,
          type: "warning",
        });
        return;
      }
      if (this.userId) {
        let params = this.getParams();
        console.log("=======================search", params);
        this.$emit("search", params);
      } else {
        // 非登录态
        this.showLogin = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../styles/tool.scss";
.search-area {
  margin: auto;
  width: 1200px;
  height: 100px;
  background: #e9f0f7;
  border-radius: 10px;
  overflow: hidden;
  .wrapper {
    width: 100%;
    height: 100%;
    padding: 0 14px;
    $colBtnW: 58px;
    $colBtnH: 46px;
    $bottomH: 54px;
    position: relative;
    $inputBtnGrid: auto $colBtnW;
    $inputGroupGrid: 334px 334px 222px auto;
    .top {
      width: 100%;
      height: 30px;
      font-size: 13px;
      font-weight: bold;
      color: #697e9d;
      display: grid;
      grid-template-columns: $inputBtnGrid;
      .input-col-group {
        display: grid;
        grid-template-columns: $inputGroupGrid;
        .col {
          //   line-height: 30px;
          display: flex;
          align-items: center;
        }
      }
    }
    .bottom {
      width: 100%;
      height: $bottomH;
      background: #ffffff;
      border-radius: 4px;
      overflow: hidden;
      .col-wrapper {
        width: 100%;
        height: $bottomH;
        display: grid;
        grid-template-columns: $inputBtnGrid;
        .input-col-group {
          display: grid;
          grid-template-columns: $inputGroupGrid;
          height: $bottomH;
          .col {
            height: $bottomH;
            position: relative;

            .port-icon-font {
              position: absolute;
              left: 20px;
              color: var(--theme);
              top: 50%;
              transform: translateY(-50%);
              -webkit-transform: translateY(-50%);
              -ms-transform: translateY(-50%);
              -moz-transform: translateY(-50%);
              -o-transform: translateY(-50%);
              z-index: 1;
              .image {
                display: block;
                width: 16px;
                height: auto;
              }
            }
            /deep/ .col-input {
              height: $bottomH;
              @include refactorElInputWidget($removeBorder: true);
              input {
                padding-left: 46px !important;
                font-size: 15px;
                height: $bottomH !important;
              }
              .input-focus-node {
                @include statusIsFocusLine();
                &.status-is-focus {
                  &:after {
                    width: 100%;
                  }
                }
              }
              .multiple-select {
                .el-select__tags {
                  padding-left: 46px !important;
                  box-sizing: border-box;
                  .el-tag {
                    padding: 0 8px;
                    height: 34px;
                    border-radius: 6px;
                    transition: background-color .35s;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: rgba(var(--theme-rgb),.06);
                    white-space: nowrap;
                    font-size: 14px;
                    color: #353744;
                    box-sizing: border-box;
                    margin: 0 10px 0 0;
                    border: none;
                    i {
                      display: none;
                    }
                    &:last-child {
                      margin: 0;
                    }
                    &:hover {
                      background: rgba(var(--theme-rgb),.1);
                    }
                  }
                }
              }
            }
            .flag-col {
              position: absolute;
              right: 6px;
              top: 50%;
              transform: translateY(-50%);
              -webkit-transform: translateY(-50%);
              -ms-transform: translateY(-50%);
              -moz-transform: translateY(-50%);
              -o-transform: translateY(-50%);
              z-index: 1;
            }
            .flag-col--start {
              right: 20px;
            }

            .col-split {
              position: absolute;
              flex: 0 0 auto;
              width: 2px;
              height: 42px;
              background: #e9f0f7;
              z-index: 1;
              right: -1px;
              top: 50%;
              transform: translateY(-50%);
              -webkit-transform: translateY(-50%);
              -ms-transform: translateY(-50%);
              -moz-transform: translateY(-50%);
              -o-transform: translateY(-50%);

              .arrow-circle {
                position: absolute;
                width: 26px;
                height: 26px;
                background: #ffffff;
                box-shadow: 1px 1px 10px 0px rgba(105, 126, 157, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                -webkit-transform: translate(-50%, -50%);
                -ms-transform: translate(-50%, -50%);
                -moz-transform: translate(-50%, -50%);
                -o-transform: translate(-50%, -50%);

                i {
                  font-weight: bold;
                  font-size: 14px;
                  color: #868a9e;
                }
              }
            }
          }
          .col-3 {
            .port-icon-font {
              //   left: 20px;
              i {
                font-size: 18px;
                color: #8a97ac;
              }
            }
          }
          .col-4 {
            .port-icon-font {
              //   left: 20px;
              i {
                font-size: 18px;
                color: #8a97ac;
              }
            }
          }
        }
        .btn-col-group {
          display: flex;
          align-items: center;
          height: $bottomH;
          justify-content: center;
          .btn-wrapper {
            width: $colBtnW;
            height: $colBtnH;
            display: flex;
            align-items: center;
            justify-content: center;
            /deep/ .button-col {
              width: 50px;
              height: 46px;
              border-radius: 8px;
              i {
                color: #fff;
                font-size: 18px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
